export default __webpack_public_path__ + "a44d68a84344a97de44c91f8e0e22711.png";